export const ANNOTATION_SHORTCUTS = Object.freeze({
  BACKSPACE: {
    key: 'Backspace',
    shortcut: 'Del',
    description: 'To delete the selected annotation'
  },
  ESCAPE: {
    key: 'Escape',
    shortcut: 'Esc',
    description: 'To escape the currently drawing annotation'
  },
  MULTI_SELECT: {
    key: 'Alt+Click',
    shortcut: 'Alt+Click',
    description: 'Allows selecting multiple annotations'
  },
  MOVE: {
    key: 'Arrow Keys',
    shortcut: 'Arrow Keys',
    description: 'Move the selected bounding box'
  },
  TOGGGLE_HIDE_SHOW_ANNOTATION: {
    key: 'h',
    shortcut: 'h',
    description: 'Toggle to hide and show the selected annotation'
  }
});
export const TASK_SHORTCUTS = Object.freeze({
  GET_TASK: {
    key: 'Alt/Option+G',
    shortcut: 'Alt/Option+G',
    description: 'Get a new task'
  },
  SUBMIT_TASK: {
    key: 'Alt/Option+S',
    shortcut: 'Alt/Option+S',
    description: 'Submit the task'
  },
  PAUSE_TASK: {
    key: 'Alt/Option+P',
    shortcut: 'Alt/Option+P',
    description: 'Pause the task'
  },
  BLOCK_TASK: {
    key: 'Alt/Option+B',
    shortcut: 'Alt/Option+B',
    description: 'Block the task'
  }
});
export const IMAGE_DRAG_SHORTCUTS = Object.freeze({
  CONTROL: {
    key: 'Option/Alt',
    shortcut: 'Option/Alt+Drag',
    description: 'Longpress option/alt key to drag the image while drawing labels'
  }
});
export const VIDEO_DRAG_SHORTCUTS = Object.freeze({
  CONTROL: {
    key: 'Option/Alt',
    shortcut: 'Option/Alt+Drag',
    description: 'Longpress option/alt key to drag the video while drawing labels'
  }
});
export const ENTITY_TAGGING_SHORTCUTS = Object.freeze({
  PLAYER: {
    PLAY_PAUSE: {
      key: 'space',
      shortcut: 'space',
      description: 'Play/Pause the media'
    },
    FAST_FORWARD: {
      key: '>',
      shortcut: '>',
      description: 'Fast forward the media by the configured number of seconds (default is 10s)'
    },
    REWIND: {
      key: '<',
      shortcut: '<',
      description: 'Rewind the media by the configured number of seconds (default is 10s)'
    },
    MOVE_TO_START: {
      key: '⌘/Ctrl + <',
      shortcut: '⌘/Ctrl + <',
      description: 'Move to the start of the media'
    },
    MOVE_TO_END: {
      key: '⌘/Ctrl + >',
      shortcut: '⌘/Ctrl + >',
      description: 'Move to the end of the media'
    },
    TOGGLE_PREVIEW: {
      key: 'p',
      shortcut: 'p',
      description: 'Toggle preview mode'
    }
  },
  ANNOTATION: {
    CREATE: {
      key: 'a',
      shortcut: 'a',
      description: 'Create an Advanced Annotation'
    },
    EDIT: {
      key: 'e',
      shortcut: 'e',
      description: 'Edit an annotation'
    },
    SUBMIT: {
      key: 'a',
      shortcut: 'a',
      description: 'Submit create/edit annotation if any'
    },
    CANCEL: {
      key: 'Escape',
      shortcut: 'Escape',
      description: 'Cancel Add/Edit action on Advanced Annotation'
    },
    SELECT_FIRST: {
      key: '⌘/Ctrl + a',
      shortcut: '⌘/Ctrl + a',
      description: 'Select the first annotation label'
    },
    SWITCH_NEXT: {
      key: 'Tab',
      shortcut: 'Tab',
      description: 'Switch to the next annotation label'
    },
    DELETE: {
      key: 'Backspace',
      shortcut: 'Backspace',
      description: 'Delete the selected annotation'
    },
    DESELECT: {
      key: 'q',
      shortcut: 'q',
      description: 'Deselect the current annotation'
    }
  }
});
export const VIDEO_SHORTCUTS = Object.freeze({
  PLAYER: {
    PLAY_PAUSE: {
      key: 'space',
      shortcut: 'space',
      description: 'Play/Pause the video'
    },
    FAST_FORWARD: {
      key: 'n',
      shortcut: 'n',
      description: 'Fast forward the video by 1 frame'
    },
    REWIND: {
      key: 'm',
      shortcut: 'm',
      description: 'Rewind the video by 1 frame'
    },
    SKIP_TO_FIRST: {
      key: '⌘/Ctrl + <',
      shortcut: '⌘/Ctrl + <',
      description: 'Move to the start of the video'
    },
    SKIP_TO_LAST: {
      key: '⌘/Ctrl + >',
      shortcut: '⌘/Ctrl + >',
      description: 'Move to the end of the video'
    },
    JUMP_FORWARD: {
      key: 'Shift + >',
      shortcut: 'Shift + >',
      description: 'Fast forward the video by 10 frames'
    },
    JUMP_BACKWARD: {
      key: 'Shift + <',
      shortcut: 'Shift + <',
      description: 'Rewind the video by 10 frames'
    }
  }
});
export const REVIEW_MODE_SHORTCUTS = Object.freeze({
  ACCEPT_LABEL: {
    key: 'Shift + a',
    shortcut: 'Shift + a',
    description: 'Approve the current label'
  },
  REJECT_LABEL: {
    key: 'Shift + r',
    shortcut: 'Shift + r',
    description: 'Reject the current label'
  },
  DELETE_INSTANCE: {
    key: 'd',
    shortcut: 'd',
    description: 'Delete the selected instance'
  },
  EDIT_ANNOTATION: {
    key: 'e',
    shortcut: 'e',
    description: 'Edit the selected object'
  },
  ADD_COMMENT: {
    key: 'c',
    shortcut: 'c',
    description: 'Add a comment to the selected object'
  },
  NEXT_ANNOTATION: {
    key: 'x',
    shortcut: 'x',
    description: 'Move to the next object'
  },
  PREVIOUS_ANNOTATION: {
    key: 'z',
    shortcut: 'z',
    description: 'Move to the previous object'
  },
  NEXT_INSTANCE: {
    key: 'k',
    shortcut: 'k',
    description: 'Move to the next instance'
  },
  PREVIOUS_INSTANCE: {
    key: 'j',
    shortcut: 'j',
    description: 'Move to the previous instance'
  },
  TOGGLE_ATTRIBUTE_EXPANSION: {
    key: 't',
    shortcut: 't',
    description: 'Toggle the attribute expansion for the current object'
  },
  BATCH_MODE_COMMENT: {
    key: 'Shift + c',
    shortcut: 'Shift + c',
    description: 'Add a comment to the selected object in batch mode'
  },
  BATCH_MODE_FEEDBACK: {
    key: 'f',
    shortcut: 'f',
    description: 'Open the task level feedback panel in batch mode'
  },
  FOCUS_MODE: {
    key: '⌘/Ctrl + f',
    shortcut: '⌘/Ctrl + f',
    description: 'Toggle focus and unfocus mode for the selected annotation'
  },
  TOGGGLE_HIDE_SHOW_ANNOTATION: {
    key: 'h',
    shortcut: 'h',
    description: 'Toggle to hide and show the selected annotation'
  }
});
export const imageAnnotationShortcutList = [{
  title: 'Task',
  hotkeys: Object.values(TASK_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Annotation',
  hotkeys: Object.values(ANNOTATION_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Image',
  hotkeys: Object.keys(IMAGE_DRAG_SHORTCUTS).map(tool => ({
    key: IMAGE_DRAG_SHORTCUTS[tool].shortcut,
    description: IMAGE_DRAG_SHORTCUTS[tool].description
  }))
}, {
  title: 'Review Mode',
  hotkeys: Object.values(REVIEW_MODE_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}];
export const entityTaggingShortcutList = [{
  title: 'Task',
  hotkeys: Object.values(TASK_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Player',
  hotkeys: Object.values(ENTITY_TAGGING_SHORTCUTS.PLAYER).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Annotation',
  hotkeys: Object.values(ENTITY_TAGGING_SHORTCUTS.ANNOTATION).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Review Mode',
  hotkeys: Object.values(REVIEW_MODE_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}];
export const videoShortcutList = [{
  title: 'Task',
  hotkeys: Object.values(TASK_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Player',
  hotkeys: Object.values(VIDEO_SHORTCUTS.PLAYER).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Annotation',
  hotkeys: Object.values(ANNOTATION_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Video',
  hotkeys: Object.values(VIDEO_DRAG_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Review Mode',
  hotkeys: Object.values(REVIEW_MODE_SHORTCUTS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}];
export const TRANSCRIPTION_SHORTCUTS = ({
  TASK: {
    SUBMIT_TASK: {
      key: 'Alt/Option + S',
      shortcut: 'Alt/Option + S',
      description: 'Submit the task'
    },
    PAUSE_TASK: {
      key: 'Alt/Option + P',
      shortcut: 'Alt/Option + P',
      description: 'Pause the task'
    },
    BLOCK_TASK: {
      key: 'Alt/Option + B',
      shortcut: 'Alt/Option + B',
      description: 'Block the task'
    }
  },
  PLAYER: {
    PLAY_PAUSE: {
      key: 'Escape',
      shortcut: 'Escape',
      description: 'Play/Pause the audio'
    },
    SKIP_FORWARD: {
      key: 'Shift + PLUS',
      shortcut: 'Shift + PLUS',
      description: 'Fast forward audio by 5 seconds'
    },
    SKIP_BACKWARD: {
      key: 'Shift + -',
      shortcut: 'Shift + -',
      description: 'Rewind audio by 5 seconds'
    },
    JUMP_FORWARD: {
      key: 'Alt/Option + →',
      shortcut: 'Alt/Option + →',
      description: 'Jump to the end of the audio'
    },
    JUMP_BACKWARD: {
      key: 'Alt/Option + ←',
      shortcut: 'Alt/Option + ←',
      description: 'Jump to the start of the audio'
    },
    INCREASE_SPEED: {
      key: '⌘/Ctrl + \\',
      shortcut: '⌘/Ctrl + \\',
      description: 'Increase the playback speed by 0.5x'
    },
    DECREASE_SPEED: {
      key: 'Shift + S',
      shortcut: 'Shift + S',
      description: 'Decrease the playback speed by 0.5x'
    }
  },
  TIMELINE: {
    ZOOM_IN: {
      key: '⌘/Ctrl + X',
      shortcut: '⌘/Ctrl + X',
      description: 'Zoom in on the timeline waveform'
    },
    ZOOM_OUT: {
      key: '⌘/Ctrl + D',
      shortcut: '⌘/Ctrl + D',
      description: 'Zoom out on the timeline waveform'
    }
  },
  TOOLS: {
    UNDO: {
      key: '⌘/Ctrl + Z',
      shortcut: '⌘/Ctrl + Z',
      description: 'Undo the last action'
    },
    REDO: {
      key: '⌘/Ctrl + Shift + Z',
      shortcut: '⌘/Ctrl + Shift + Z',
      description: 'Redo the last undone action'
    },
    POINTER: {
      key: 'S',
      shortcut: 'S',
      description: 'Deselect the selected annotation'
    },
    SHOW_ML_ANNOTATION: {
      key: 'Shift + P(Hold)',
      shortcut: 'Shift + P',
      description: 'Previews the ML annotation pre populated in the task'
    },
    MULTI_SELECT_SLOTS: {
      key: '⌘/Ctrl (hold) + Click',
      shortcut: '⌘/Ctrl + Click',
      description: 'Select multiple slots by clicking on them'
    }
  },
  SLOT: {
    EDIT_SLOT: {
      key: 'Alt/Option + E',
      shortcut: 'Alt/Option + E',
      description: 'Edit the selected slot'
    },
    MARK_COMPLETE: {
      key: 'Alt/Option + C',
      shortcut: 'Alt/Option + C',
      description: 'Mark the selected slot as complete'
    },
    DELETE_SLOT: {
      key: 'Alt/Option + D',
      shortcut: 'Alt/Option + D',
      description: 'Delete the selected slot (when editing)'
    },
    SAVE_CHANGES: {
      key: 'Alt/Option + A',
      shortcut: 'Alt/Option + A',
      description: 'Save changes to the selected slot (when editing)'
    }
  },
  REVIEW_MODE: {
    ACCEPT_SLOT: {
      key: 'Shift + a',
      shortcut: 'Shift + a',
      description: 'Approve the current selected slot'
    },
    REJECT_SLOT: {
      key: 'Shift + r',
      shortcut: 'Shift + r',
      description: 'Reject the current selected slot or Redo an approved / rejected slot'
    },
    COMMENT_SLOT: {
      key: 'Shift + c',
      shortcut: 'Shift + c',
      description: 'Add a comment to the current selected slot'
    },
    FEEDBACK_DRAWER: {
      key: 'Shift + f',
      shortcut: 'Shift + f',
      description: 'Open the feedback drawer'
    }
  }
} as const);
export const transcriptionShortcutList = [{
  title: 'Task',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.TASK).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Player',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.PLAYER).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Timeline',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.TIMELINE).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Tools',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.TOOLS).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Slot',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.SLOT).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}, {
  title: 'Review Mode',
  hotkeys: Object.values(TRANSCRIPTION_SHORTCUTS.REVIEW_MODE).map(shortcut => ({
    key: shortcut.key,
    description: shortcut.description
  }))
}];